import { executeFetch } from '../actions'

export const fetchTableData = async (body, selectedStore) => {
  const queryParams = selectedStore?.id ? `?store=${selectedStore.id}` : ''

  const url = `/output/store-collaboration/space-occupancy/table${queryParams}`

  try {
    return await executeFetch(url, body, 'POST')
  } catch (error) {
    return { items: [], metadata: { pagination: { total: 0 } } }
  }
}
